// import Swiper JS
import Swiper from 'swiper';
import { EffectFade, Navigation, Pagination, Autoplay } from 'swiper/modules'
// import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-fade';

export const clientSlider = () => {
	new Swiper('.js-client-slider', {
		modules: [Navigation, Autoplay],
		slidesPerView: 3,
		spaceBetween: 16,
		loop: true,
		speed: 5000,
		allowTouchMove: false,
		autoplay: {
			delay: 0,
			disableOnInteraction: false,
		},
		// If we need pagination
		pagination: {
			el: '.swiper-pagination',
		},
		breakpoints: {
			// when window width is >= 320px
			1200: {
				slidesPerView: 6,
				spaceBetween: 66,
			},
			768: {
				slidesPerView: 4,
			},
		}
	});
}

export const newsSlider = () => {
	new Swiper('.js-news-slider', {
		modules: [Navigation],
		slidesPerView: 1.5,
		spaceBetween: 16,
		navigation: {
			nextEl: '.news-swiper-button-next',
			prevEl: '.news-swiper-button-prev',
		},
		breakpoints: {
			1200: {
				spaceBetween: 24,
				slidesPerView: 3,
			},
		}
	});
}
export const newsSliderv2 = () => {
	new Swiper('.js-news-slider-v2', {
		modules: [Navigation],
		slidesPerView: 1.1,
		spaceBetween: 16,
		navigation: {
			nextEl: '.news-v2-swiper-button-next',
			prevEl: '.news-v2-swiper-button-prev',
		},
		breakpoints: {
			1200: {
				spaceBetween: 24,
				slidesPerView: 3,
			},
			430: {
				spaceBetween: 16,
				slidesPerView: 2.2,
			},
		}
	});
}

export const demosSlider = () => {
	const sliders = document.querySelectorAll('.js-demo-slider');

	sliders && sliders.forEach(sliderEl => {
		const slides = sliderEl.querySelectorAll('.swiper-slide');
		const slidesCount = slides.length;

		// default config
		let desktopSlides = 4;

		if (slidesCount <= 3) {
			desktopSlides = slidesCount;
		}

		new Swiper(sliderEl, {
			modules: [Navigation],
			slidesPerView: 1.3,
			spaceBetween: 16,
			navigation: {
				// scope buttons to this slider instance
				nextEl: sliderEl.querySelector('.demo-swiper-button-next'),
				prevEl: sliderEl.querySelector('.demo-swiper-button-prev'),
			},
			breakpoints: {
				1370: {
					spaceBetween: 24,
					slidesPerView: desktopSlides,
				},
				1270: {
					spaceBetween: 16,
					slidesPerView: Math.min(desktopSlides, 3),
				},
				991: {
					slidesPerView: Math.min(desktopSlides, 2.5),
				},
				768: {
					slidesPerView: 1.5,
				},
			}
		});
	});
}

export const blocksSlider = () => {
	const sliders = document.querySelectorAll('.js-blocks-slider');

	sliders && sliders.forEach(sliderEl => {
		const slides = sliderEl.querySelectorAll('.swiper-slide');
		const slidesCount = slides.length;

		// default config
		let desktopSlides = 4;

		if (slidesCount <= 3) {
			desktopSlides = slidesCount;
		}

		new Swiper(sliderEl, {
			modules: [Navigation],
			slidesPerView: 1.3,
			spaceBetween: 16,
			navigation: {
				// scope buttons to this slider instance
				nextEl: sliderEl.querySelector('.blocks-swiper-button-next'),
				prevEl: sliderEl.querySelector('.blocks-swiper-button-prev'),
			},
			breakpoints: {
				1370: {
					spaceBetween: 24,
					slidesPerView: desktopSlides,
				},
				1270: {
					spaceBetween: 16,
					slidesPerView: Math.min(desktopSlides, 3),
				},
				991: {
					slidesPerView: Math.min(desktopSlides, 2.5),
				},
				768: {
					slidesPerView: 1.5,
				},
			}
		});
	});
}

export const fadeSlider = () => {
	const sliders = document.querySelectorAll('.js-fade-slider');

	sliders.forEach(sliderEl => {
		const swiper = new Swiper(sliderEl, {
			modules: [EffectFade],
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
			speed: 1000,
			autoHeight: true,
		});

		if (window.innerWidth < 991) {
			const btnsContainer = sliderEl.parentElement.querySelector('.js-fade-slider-btns');
			if (btnsContainer) {
				new Swiper(btnsContainer, {
					slidesPerView: 'auto',
					spaceBetween: 8,
				});
			}
		}

		const buttons = sliderEl.parentElement.querySelectorAll('.js-fade-slider-button');
		buttons.forEach(btn => {
			btn.addEventListener('click', () => {
				const targetIndex = parseInt(btn.getAttribute('data-slide'), 10);
				swiper.slideTo(targetIndex);
			});
		});
	});
}


export const rewardsSlider = () => {
	const sliders = document.querySelectorAll('.js-rewards-slider');

	sliders && sliders.forEach(sliderEl => {
		const slidesCount = sliderEl.querySelectorAll('.swiper-slide').length;

		new Swiper(sliderEl, {
			modules: [Navigation],
			slidesPerView: 1.3,
			spaceBetween: 16,
			// a single reward is centered instead of sticking to the left
			centerInsufficientSlides: slidesCount === 1,
			navigation: {
				// scope buttons to this slider instance
				nextEl: sliderEl.querySelector('.rewards-swiper-button-next'),
				prevEl: sliderEl.querySelector('.rewards-swiper-button-prev'),
			},
			breakpoints: {
				1370: {
					spaceBetween: 24,
					slidesPerView: 4.5,
				},
				1270: {
					spaceBetween: 16,
					slidesPerView: 3,
				},
				991: {
					slidesPerView: 2.5,
				},
				768: {
					slidesPerView: 1.5,
				},
			}
		});
	});
}
